export default function oversToBalls(overs) {
    const stringOvers = String(overs)

    const ovs = Number(stringOvers.split('.')[0])
    const part = Number(stringOvers.split('.')[1])

    let balls = ovs * 5

    if (part) {
        balls += part
    }

    return balls
}